import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import axios from "axios";
import { APIURL, TZ } from "../../../Global";
import { Modal } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import DatePicker from 'react-date-picker';
import { useAlert } from "react-alert";
import { DosageOptions, RouteOptions, StrengthOptions, medicinclasses } from './formOptions.js';
import CustomSelect from './CustomSelect.js';
function EditMedicine(props) {
  const alert = useAlert();
  const [completeShow, setCompleteShow] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [data, setData] = useState(props.data);
  const [dosage_type, setDosageType] = useState(null);
  const [med_type, setMedicinetype] = useState(null);
  const [strengthunit, setStrengthUnit] = useState(null);
  const [routine, setRoutine] = useState(null);
  const [errormsg, setErrorMsg] = useState("");
  const [successShow, setSuccessShow] = useState(false);
  const [errorShow, setErrorShow] = useState(false);

  // Initialize form fields when props.data changes
  useEffect(() => {
    if (props.data) {
      setData(props.data);

      // Initialize dropdown values
      if (props.data.dosage_form) {
        const dosageOption = DosageOptions.find(opt => opt.value === props.data.dosage_form);
        setDosageType(dosageOption || null);
      }

      if (props.data.med_type) {
        const medTypeOption = medicinclasses.find(opt => opt.value === props.data.med_type);
        setMedicinetype(medTypeOption || null);
      }

      if (props.data.strength_unit) {
        const strengthOption = StrengthOptions.find(opt => opt.value === props.data.strength_unit);
        setStrengthUnit(strengthOption || null);
      }

      if (props.data.route) {
        const routeOption = RouteOptions.find(opt => opt.value === props.data.route);
        setRoutine(routeOption || null);
      }
    }
  }, [props.data]);

  const [error, setError] = useState({
    medicinename: '',
    genericname: '',
    strength: '',
    medicinetype: '',
    dosage_type: '',
    medicinecode: '',
    routine: '',
    strengthunit: '',
    composition: ''
  });

  const validate = () => {
    let input = data;
    let errors = {};
    let isValid = true;

    if (!input["med_name"] || input["med_name"].trim() === "") {
      isValid = false;
      errors["medicinename"] = "Enter generic name of medicine";
    }

    if (!input["strength"] || input["strength"].trim() === "") {
      isValid = false;
      errors["strength"] = "Enter strength of medicine";
    }
    
    if (!input["composition"] || input["composition"].trim() === "") {
      isValid = false;
      errors["composition"] = "Enter composition";
    }

    if (!med_type || !med_type.value) {
      isValid = false;
      errors["medicinetype"] = "Select medicine type";
    }

    if (!dosage_type || !dosage_type.value) {
      isValid = false;
      errors["dosage_type"] = "Select dosage type";
    }

    if (!routine || !routine.value) {
      isValid = false;
      errors["routine"] = "Select route";
    }

    if (!input["med_code"] || input["med_code"].trim() === "") {
      isValid = false;
      errors["medicinecode"] = "Enter medicine code";
    }

    if (!strengthunit || !strengthunit.value) {
      isValid = false;
      errors["strengthunit"] = "Select strength unit";
    }

    if (input["med_url"] && input["med_url"].trim() !== "") {
      const regex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      const pattern = new RegExp(regex);
      if (!pattern.test(input["med_url"])) {
        isValid = false;
        errors["med_url"] = "Enter a valid URL";
      }
    }

    setError(errors);
    return isValid;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setData(prev => ({
      ...prev,
      [name]: value
    }));

    setError(prev => ({
      ...prev,
      [name]: ""
    }));
  };

  const saveChanges = () => {
    if (validate()) {
      const tokenString = sessionStorage.getItem("usertoken");
      const token = tokenString.replace(/["]+/g, "");

      const updatedData = {
        ...data,
        med_type: med_type?.value || '',
        dosage_form: dosage_type?.value || '',
        strength_unit: strengthunit?.value || '',
        route: routine?.value || ''
      };

      axios.put(`${APIURL}/api/v1/staff/master-medicine-detail/${data.id}/`, updatedData, {
        headers: { Authorization: "Token " + token },
      })
        .then((res) => {
          if (res.data.status === "success") {
            alert.success(res.data.message);
            props.modalClose();
            if (props.onSuccess) {
              props.onSuccess(); // Optional callback for parent component
            }
          } else {
            alert.error(res.data.message);
          }
        })
        .catch((err) => {
          alert.error("Failed to update medicine. Please try again.");
          console.error("Update error:", err);
        });
    }
  };

  const handleImageUpload = (event) => {
    const image = event.target.files[0];
    setData(prev => ({ ...prev, image: URL.createObjectURL(image) }));
    setSelectedImage(image);
  };

  return (
    <>
      <h4 style={{ marginTop: '0' }} className="title-of-page">Edit Medicine</h4>
      <div className='medicine-form-container'>
        <div className='form-section'>
          <div className='flex-display'>
            <div className='pricing-inputcontainer col-8'>
              <label className='required'>Generic Name</label>
              <input
                className={`${error.medicinename ? 'has-error-input' : ''}`}
                type='text'
                maxLength="300"
                name='med_name'
                value={data.med_name || ''}
                onChange={handleInputChange}
              />
              {error.medicinename && <div className="error-message">{error.medicinename}</div>}
            </div>
            <div className='pricing-inputcontainer col-4 '>
              <label className='required'>ATC Code</label>
              <input
                className={`${error.medicinecode ? 'has-error-input' : ''}`}
                type='text'
                maxLength="300"
                name='med_code'
                value={data.med_code || ''}
                onChange={handleInputChange}
              />
              {error.medicinecode && <div className="error-message">{error.medicinecode}</div>}
            </div>
          </div>

          <div className='flex-display'>
            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Strength</label>
              <input
                className={`${error.strength ? 'has-error-input' : ''}`}
                type='text'
                maxLength="300"
                name='strength'
                value={data.strength || ''}
                onChange={handleInputChange}
              />
              {error.strength && <div className="error-message">{error.strength}</div>}
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Strength Unit</label>
              <CustomSelect
                label="Strength unit"
                value={strengthunit}
                onChange={setStrengthUnit}
                options={StrengthOptions}
                error={error.strengthunit}
              />
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label>Manufacturer Name</label>
              <input
                type='text'
                maxLength="100"
                name='manufacturer_name'
                value={data.manufacturer_name || ''}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className='flex-display'>
            <div className='pricing-inputcontainer col-4'>
              <label>Manufacturer Address</label>
              <textarea
                maxLength="400"
                name='manufacturer_address'
                value={data.manufacturer_address || ''}
                onChange={handleInputChange}
              />
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Composition</label>
              <textarea
                className={`${error.composition ? 'has-error-input' : ''}`}
                maxLength="400"
                name='composition'
                value={data.composition || ''}
                onChange={handleInputChange}
              />
              {error.composition && <div className="error-message">{error.composition}</div>}
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label>Description</label>
              <textarea
                maxLength="500"
                name='description'
                value={data.description || ''}
                onChange={handleInputChange}
              />
            </div>
          </div>

          <div className='flex-display'>
            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Medicine Type</label>
              <CustomSelect
                value={med_type}
                onChange={setMedicinetype}
                options={medicinclasses}
                error={error.medicinetype}
              />
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Dosage</label>
              <CustomSelect
                value={dosage_type}
                onChange={setDosageType}
                options={DosageOptions}
                error={error.dosage_type}
              />
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label className='required'>Route</label>
              <CustomSelect
                value={routine}
                onChange={setRoutine}
                options={RouteOptions}
                error={error.routine} />
            </div>
          </div>

          <div className='flex-display'>
            <div className='pricing-inputcontainer col-4'>
              <label>Drug Interactions</label>
              <textarea
                name='med_interactions'
                value={data.med_interactions || ''}
                onChange={handleInputChange}
              />
            </div>

            <div className='pricing-inputcontainer col-4'>
              <label>Drug Interactions URL</label>
              <textarea
                type="text"
                placeholder="https://www.example.com"
                className={`${error.med_url ? 'has-error' : ''}`}
                name='med_url'
                value={data.med_url || ''}
                onChange={handleInputChange}
              />
              {error.med_url && <div className="error-message">{error.med_url}</div>}
            </div>
          </div>
        </div>

        <div className='form-actions'>
          <button onClick={saveChanges} style={{ marginLeft: "auto" }} className='add-btn'>Save</button>
        </div>
      </div>
    </>
  );
}

export default EditMedicine;
